import React from 'react';
import AccessDeniedImg from "assets/img/access-denied.svg";
import utils, { CUSTOM_MESSAGES } from 'utils';

export const AccessDenied = () => {
    return (
        <div className="container text-center" style={{ height: '100vh' }}>
            <code>{utils.ImagePreviewContainer(AccessDeniedImg, 400, 30, CUSTOM_MESSAGES.ACCESS_DENIED_MESSAGE)}</code>
        </div>
    );
}